module.exports = "<section>\r\n    <a href=\"\">\r\n        <img src={{imgDestination}} />\r\n        <h3>{{title}}</h3>\r\n    </a>\r\n</section>"